/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Constants } from '../../../Constants';
import { License } from '../../../models/common/License';
import { ValidationRuleMetaData } from '../../ValidationRuleMetaData';
import { RequiredPropertyValidationRule } from './RequiredPropertyValidationRule';

/**
 * Constructor.
 * @param {ValidationRuleMetaData} ruleInfo
 * @class
 * @extends RequiredPropertyValidationRule
 * @author eric.wittmann@gmail.com
 */
export class MissingLicenseNameRule extends RequiredPropertyValidationRule {
    public constructor(ruleInfo : ValidationRuleMetaData) {
        super(ruleInfo);
    }

    /**
     * @see io.apicurio.datamodels.combined.visitors.CombinedAllNodeVisitor#visitLicense(io.apicurio.datamodels.core.models.common.License)
     * @param {License} node
     */
    public visitLicense(node : License) {
        this.requireProperty(node, Constants.PROP_NAME, this.map.apply(this, ));
    }
}
MissingLicenseNameRule["__class"] = "io.apicurio.datamodels.core.validation.rules.required.MissingLicenseNameRule";
MissingLicenseNameRule["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.asyncapi.v2.visitors.IAai20Visitor","io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor","io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor","io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor","io.apicurio.datamodels.openapi.visitors.IOasVisitor"];




